import { IField } from "../interfaces/Field";

export function ToSizeFields(x: number, y: number, width: number, height: number, textWidth?: number, dottedSpacing?: number): IField[]{
    let fields = [
        {name: "X", value: x.toString()},
        {name: "Y", value: y.toString()},
        {name: "Width", value: width.toString()},
        {name: "Height", value: height.toString()},
        {name: "Scale", value: "1"}
    ];
    if(textWidth !== undefined){
        fields.push({name: "Text Width", value: textWidth.toString()});
    }
    if(dottedSpacing !== undefined){
        fields.push({name: "Dotted Spacing", value: dottedSpacing.toString()});
    }
    return fields;
}
